import { Box, Icon } from 'dash-ui';
import { Dispatch, SetStateAction, useEffect, useMemo } from 'react';
import { useTheme } from 'styled-components';

import { ICurrencyInputValues } from 'pages/Dashboard/components/CurrencyConverterWidget/CurrencyConverterWidget.interfaces';
import { getRateByCurrency } from 'pages/Dashboard/components/CurrencyConverterWidget/CurrencyConverterWidget.helpers';

import CurrencyInput from './components/CurrencyInput/CurrencyInput';
import { IconWrapper } from './CurrencyConvertorInputs.styles';

const CurrencyConvertorInputs = ({
  inputValues,
  setInputValues,
  rates,
}: {
  inputValues: ICurrencyInputValues;
  setInputValues: Dispatch<SetStateAction<ICurrencyInputValues>>;
  rates: Record<string, number>;
}) => {
  const theme = useTheme();

  const options = useMemo(() => {
    return Object.keys(rates).map((key) => ({
      value: key,
      label: key,
    }));
  }, [rates]);

  const defaultValue = useMemo(() => {
    const topPrice = Number(inputValues.top.price);
    const bottomCurrency = inputValues.bottom.currency;
    const topCurrency = inputValues.top.currency;
    const rate = getRateByCurrency(rates, topCurrency, bottomCurrency);

    return rate ? (topPrice * rate).toFixed(2).toString() : '';
  }, [inputValues, rates]);

  const handleInputsChange =
    (position: string) => (key: string) => (value: string) => {
      setInputValues((prev: any) => ({
        ...prev,
        [position]: {
          ...prev[position],
          [key]: value,
        },
      }));
    };

  useEffect(() => {
    setInputValues((prev) => ({
      ...prev,
      bottom: { ...prev.bottom, price: defaultValue },
    }));
  }, [defaultValue, setInputValues]);

  return (
    <Box pos="relative">
      <Box mb={2}>
        <CurrencyInput
          placeholder="670,400.00"
          defaultCurrency={inputValues.top.currency}
          defaultValue={inputValues.top.price}
          onInputChange={handleInputsChange('top')('price')}
          onSelectChange={handleInputsChange('top')('currency')}
          options={options}
        />
      </Box>
      <CurrencyInput
        placeholder="679,231.49"
        defaultCurrency={inputValues.bottom.currency}
        defaultValue={defaultValue}
        onInputChange={handleInputsChange('bottom')('price')}
        onSelectChange={handleInputsChange('bottom')('currency')}
        options={options}
      />
      <IconWrapper
        pos="absolute"
        justifyContent="center"
        alignItems="center"
        w={32}
        h={32}
        onClick={() => {
          setInputValues((prev) => ({
            top: { ...prev.top, currency: prev.bottom.currency },
            bottom: { ...prev.bottom, currency: prev.top.currency },
          }));
        }}
      >
        <Icon name="swapVert" size={20} color={theme.colors.b50} />
      </IconWrapper>
    </Box>
  );
};

export default CurrencyConvertorInputs;
